import "./style.scss";

import "./PhotoSwipeGallery";

import $ from "jquery";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

const figureSelector = "li.blocks-gallery-item > figure";
const galleryData = window.GALLERY_IMAGE_SOURCES;

function initGallery(galleryElement, imageSources) {
  const $figures = $(galleryElement).find(figureSelector);

  const items = $figures.get().map((el, i) => {
    if (!imageSources[i]) return null;

    const [src, w, h] = imageSources[i];

    return {
      src,
      w,
      h,
      msrc: $(el)
        .find("img")
        .attr("src"),
      el
    };
  });

  const options = {
    getThumbBoundsFn(id) {
      const pageYScroll = $(window).scrollTop();
      const { top, left, width } = $(items[id].el)
        .find("img")
        .get(0)
        .getBoundingClientRect();

      return { x: left, y: top + pageYScroll, w: width };
    }
  };

  $figures.click(evt => {
    evt.preventDefault();

    const gallery = new PhotoSwipe(
      $(".pswp").get(0),
      PhotoSwipeUI_Default,
      items,
      {
        ...options,
        index: $figures.index(
          $(evt.target)
            .closest(figureSelector)
            .get(0)
        )
      }
    );

    gallery.init();
  });
}

if (galleryData)
  $(".wp-block-gallery").each((i, el) => {
    const imageSources = galleryData[i];
    if (imageSources) initGallery(el, imageSources);
  });
